module.exports = __webpack_public_path__ + "img/cn_5.e370e3b7.jpg";